import React from "react";

const AcademicInfo = (props) => {
  return (
    <div className="card">
      <h3>Academic Information</h3>
      <div className="card-body">
        {props.data?.uncommonNewData?.gpa && (
          <div class="datas">
            <p>GPA:</p>
            <del>{props.data?.uncommonOldData?.gpa}</del>
            <span>{props.data?.uncommonNewData?.gpa}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.act && (
          <div class="datas">
            <p>ACT:</p>
            <del>{props.data?.uncommonOldData?.act}</del>
            <span>{props.data?.uncommonNewData?.act}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.sat && (
          <div class="datas">
            <p>SAT:</p>
            <del>{props.data?.uncommonOldData?.sat}</del>
            <span>{props.data?.uncommonNewData?.sat}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.classRank && (
          <div class="datas">
            <p>Class Rank:</p>
            <del>{props.data?.uncommonOldData?.classRank}</del>
            <span>{props.data?.uncommonNewData?.classRank}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.highSchoolName && (
          <div class="datas">
            <p>High School Name:</p>
            <del>{props.data?.uncommonOldData?.highSchoolName}</del>
            <span>{props.data?.uncommonNewData?.highSchoolName}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.highSchoolCityState && (
          <div class="datas">
            <p>High School (City, State):</p>
            <del>{props.data?.uncommonOldData?.highSchoolCityState}</del>
            <span>{props.data?.uncommonNewData?.highSchoolCityState}</span>
          </div>
        )}
        {props.data?.uncommonNewData?.intendedMajor && (
          <div class="datas">
            <p>Intended Major:</p>
            <del>{props.data?.uncommonOldData?.intendedMajor}</del>
            <span>{props.data?.uncommonNewData?.intendedMajor}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcademicInfo;
